import { render, staticRenderFns } from "./CreditNoteHeader.vue?vue&type=template&id=7bfb17a6&scoped=true&"
import script from "./CreditNoteHeader.vue?vue&type=script&lang=js&"
export * from "./CreditNoteHeader.vue?vue&type=script&lang=js&"
import style0 from "./CreditNoteHeader.vue?vue&type=style&index=0&id=7bfb17a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfb17a6",
  null
  
)

export default component.exports